import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2 } from "lucide-react";
import { api, data } from "@/lib/api";
import { useAuth } from "@/context/Auth";
import { Page } from "@/components/Layout";

export default function EsitoPiano() {
  const [sp] = useSearchParams();
  const { user } = useAuth();
  const [d, setD] = useState({ stato: "in_attesa" });
  useEffect(() => {
    let n = 0;
    let t;
    const poll = async () => {
      try {
        const { data: r } = await api.get(`/pubblico/piano/esito/${sp.get("session_id")}`);
        setD(r);
        if (r.stato !== "pagato" && n++ < 30) t = setTimeout(poll, 2500);
      } catch {
        setD({ stato: "errore" });
      }
    };
    poll();
    return () => clearTimeout(t);
  }, [sp]);
  const loggato = user && user.ruolo === "operatore";
  return (
    <Page className="max-w-lg">
      <div className="card text-center py-12" data-testid="esito-piano">
        {d.stato === "pagato" ? (
          <>
            <CheckCircle2 size={56} className="mx-auto text-emerald-700" />
            <h1 className="font-display text-4xl mt-4" data-testid="esito-piano-ok">Pagamento ricevuto</h1>
            <p className="text-[#786E65] mt-2">Spazio valido fino al {data(d.scadenza_spazio)}.
              {d.stato_operatore === "pagato_da_completare" && " Ora completa la tua vetrina e inviala in revisione."}</p>
            {loggato ? (
              <Link to="/aziende/pannello?tab=vetrina" className="btn-primary mt-6" data-testid="esito-vetrina-btn">Completa la vetrina</Link>
            ) : (
              <>
                <p className="text-sm text-[#786E65] mt-4">Conferma l'indirizzo email con il link che ti abbiamo inviato, poi accedi al pannello.</p>
                <Link to="/aziende/accedi" className="btn-primary mt-6" data-testid="esito-accedi-btn">Accedi</Link>
              </>
            )}
          </>
        ) : d.stato === "errore" ? (
          <p data-testid="esito-piano-errore">Pagamento non trovato.</p>
        ) : (
          <>
            <Loader2 size={48} className="mx-auto animate-spin text-[#7E5BAF]" />
            <h1 className="font-display text-3xl mt-4">Conferma del pagamento in corso…</h1>
            <p className="text-[#786E65] mt-2">Lo stato passa a pagato appena riceviamo la conferma firmata da Stripe.</p>
          </>
        )}
      </div>
    </Page>
  );
}
